import http from '@/api/http';
import moment from 'moment';
export function getLicensePage(params) {
    return http.get(`/license`, { params });
}
export function getLicenseBySeq(seq) {
    return http.get(`/license/${seq}`);
}
export class LicenseForm {
    constructor(companyId) {
        this.companyId = companyId;
    }
    liSeq;
    companyId = '';
    liCoSeq = 0;
    liPrdSeq = 0;
    licenseCount = 0;
    endDate = moment().format('YYYY-MM-DD');
    status = 1;
    valid = false;
}
export function addLicense(license) {
    return http.post(`/license`, license);
}
export function updateLicense(license) {
    return http.post(`/license`, license);
}
